module.exports = __webpack_public_path__ + "assets/img/smartTV-module1-3.2d54ed8b.jpg";